<template>
  <div class="exchangeCount">
    <div class="integralBreadcrumb">
      <div @click="jumpToMy">我的</div>
      <div class="el-icon-arrow-right"></div>
      <div @click="jumpTointegralExchange">积分兑换</div>
      <div class="el-icon-arrow-right"></div>
      <div @click="jumpToExchangeDetail">商品详情</div>
      <div class="el-icon-arrow-right"></div>
      <div>立即兑换</div>
    </div>
    <div class="countArea">
      <h2>收货地址</h2>
      <ul v-if="addressList" class="addList">
        <li
          v-for="(item, index) in addressList"
          :key="index"
        >
          <div class="addListInfo">
            <div class="addListInfo1">{{item.receiveGoodsPerson}} {{item.receiveGoodsPhone}}<span v-if="item.defaultAddress">默认</span></div>
            <div class="addListInfo2">
              <div><span class="addListInfo22"></span> {{item.province}}-{{item.city}}-{{item.area}}-{{item.address}}</div>
            </div>
          </div>
          <div class="addListFunction">
            <el-checkbox style="margin-top: 40px;" @change="hh(index, item)" v-model="ss[index]"></el-checkbox>
          </div>
        </li>
      </ul>
      <div v-if="addressList" class="doclist-pagination">
        <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':'pageDeavtive'" v-for="(item, index) in pageList" :key="index" @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump" @click="jumpFarPage">确定</div>
      </div>
      <div style="width: 100%;height: 30px;border-bottom: 1px solid #eeeeee;"></div>
      <div class="productAndCount">
        <h3>商品信息</h3>
        <div class="productInfo" v-if="info">
          <img :src="info.thumbnailUrl" :alt="info.commodityName"/>
          <div>
            <h4>{{info.commodityName}}</h4>
            <p>数量：<span style="font-weight: bold;color: #333333;"> x{{this.$route.query.num}}</span></p>
            <p>所需积分：<span style="font-weight: bold;color: #333333;">{{info.needIntegral}} x{{this.$route.query.num}}</span></p>
          </div>
        </div>
      </div>
      <div class="finalCount" v-if="info">
        <div class="finalCount0 finalCount01"><div class="finalCount1 finalCount11">可用积分：</div><div class="finalCount2 finalCount21">{{availableIntegral}}分</div></div>
        <div class="finalCount0 finalCount02"><div class="finalCount1 finalCount12">兑换所需积分：</div><div class="finalCount2 finalCount22">{{info.needIntegral * this.$route.query.num}}分</div></div>
        <div class="finalCount0 finalCount03"><div class="finalCount1 finalCount13">剩余积分：</div><div class="finalCount2 finalCount23">{{availableIntegral - (info.needIntegral * this.$route.query.num)}}分</div></div>
      </div>
      <div @click="confirmChange" class="confirmCount">
        确认兑换
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      ss: [],
      activeAddress: null,
      info: null,
      num: 1,
      availableIntegral: null,
      // 收货地址分页
      addressList: null,
      deleteMask: false,
      deleteId: null,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  methods: {
    confirmChange () {
      // console.log(this.availableIntegrall - (this.info.needIntegral * parseInt(this.$route.query.num)))
      if (this.activeAddress === null) {
        this.$message.warning('请选择收获地址')
      } else if (this.availableIntegrall - (this.info.needIntegral * parseInt(this.$route.query.num)) < 0) {
        this.$message.warning('您的可用积分不足，请重新选择商品及数量')
      } else {
        this.$http.post(`/front/train/forum/integralOrder/exchange`, {
          id: this.$route.query.id,
          count: this.$route.query.num,
          needIntegral: this.info.needIntegral * this.$route.query.num,
          userAddressId: this.activeAddress.userAddressId
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('兑换成功')
              this.$router.push({ name: 'integralOrder' })
            }
          })
          .catch(() => {
            // this.$message.error(error.response.data.message)
          })
      }
    },
    hh (index, item) {
      for (let i = 0; i < this.ss.length; i++) {
        this.ss[i] = false
      }
      this.ss[index] = true
      this.activeAddress = item
    },
    jumpToMy () {
      this.$router.push({ name: 'basicInfo' })
    },
    jumpTointegralExchange () {
      this.$router.push({ name: 'integralExchange' })
    },
    jumpToExchangeDetail () {
      this.$router.push({
        name: 'exchangeGoodDetail',
        query: {
          id: this.$route.query.id
        }
      })
    },
    confirmAddDelete () {
      // let deleteIdList = []
      // deleteIdList.push(this.deleteId)
      this.$http.post(`/front/consumer/user/address/deleteById/${this.deleteId}`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success('地址删除成功')
            this.getAddressList()
            this.handleClose()
          } else {
            // this.$message.error(data.result.msg)
          }
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    },
    handleClose () {
      this.deleteMask = false
      this.deleteId = null
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      for (let i = 0; i < this.ss.length; i++) {
        this.ss[i] = false
      }
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      this.getAddressList()
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4) {
            var newPageList3 = []
            for (let index = this.jumpTargetPage - 2; index < this.jumpTargetPage + 3; index++) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getAddressList()
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getAddressList () {
      this.$request.postParam(`/front/consumer/user/address/selectUserAddressList`, {
        page: this.currentPage,
        limit: 10
      })
        .then(data => {
          this.addressList = data.data || []
          for (let index = 0; index < data.data.length; index++) {
            this.ss.push(false)
          }
          if (data.data[0].defaultAddress === true) {
            this.ss[0] = true
            this.activeAddress = data.data[0]
          }
          this.totalPage = Math.ceil(data.count / 10)
          let newPageList = []
          if (this.totalPage <= 5) {
            for (let i = 1; i <= this.totalPage; i++) {
              newPageList.push(i)
            }
            this.pageList = newPageList
            this.nextOmit = ''
          }
        })
    },
    getGoodDetail () {
      this.$request.get(`/front/train/forum/integralExchangeCommodity/info/${this.$route.query.id}`)
        .then(data => {
          this.info = data
        })
    },
    getIntegral () {
      this.$request.get(`/front/train/forum/integralOrder/myUserPoint`)
        .then((data) => {
          this.availableIntegral = data.userPoint
        })
    }
  },
  created () {
    this.getAddressList()
    this.getGoodDetail()
    this.getIntegral()
  }
}
</script>

<style scoped>
.exchangeCount{
  width: 1190px;
  margin: 0 auto;
}
.integralBreadcrumb{
  display: flex;
  height: 20px;
  line-height: 20px;
  margin: 20px 0;
}
.integralBreadcrumb div:nth-of-type(1){
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(1):hover{
  font-weight: bold;
  color: #1D65A8;
}
.integralBreadcrumb div:nth-of-type(2){
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(3){
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(3):hover{
  font-weight: bold;
  color: #1D65A8;
}
.integralBreadcrumb div:nth-of-type(4){
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(5){
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(5):hover{
  font-weight: bold;
  color: #1D65A8;
}
.integralBreadcrumb div:nth-of-type(6){
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(7){
  font-weight: normal;
  font-size: 14px;
  color: #1D65A8;
  user-select: none;
}
.countArea{
  width: 1190px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 40px;
  background: #ffffff;
}
.countArea h2{
  height: 80px;
  line-height: 80px;
  font-size: 22px;
  color: #333333;
  font-weight: 600;
  border-bottom: #eeeeee;
}
.addList{
  margin-bottom: 30px;
}
.addList li{
  height: 98px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  user-select: none;
}
.addListInfo{
  flex: 1;
  padding-top: 23px;
  padding-bottom: 23px;
}
.addListInfo1{
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 18px;
}
.addListInfo1 span{
  display: inline-block;
  width: 35px;
  height: 20px;
  line-height: 20px;
  background: #1D65A8;
  color: #ffffff;
  font-weight: normal;
  font-size: 12px;
  text-align: center;
  margin-left: 20px;
  transform: scale(0.8) translateY(-2px)
}
.addListInfo2{
  font-size: 14px;
  height: 18px;
  line-height: 18px;
  color: #333333;
}
.addListInfo22{
  display: inline-block;
  vertical-align: middle;
  width: 14px;
  height: 18px;
  background: url(data:image/png;base64,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) no-repeat;
  background-size: 14px 18px;
  margin: 0 14px 0 0;
}
.addListFunction{
  width: 116px;
  display: flex;
}
.editIcon{
  width: 58px;
}
.editIcon i{
  display: block;
  width: 14px;
  height: 14px;
  margin: auto;
  margin-top: 40px;
  transform: scale(1.5);
  user-select: none;
  cursor: pointer;
}
.deleteIcon{
  width: 58px;
}
.deleteIcon i{
  display: block;
  width: 14px;
  height: 14px;
  margin: auto;
  margin-top: 40px;
  transform: scale(1.5);
  user-select: none;
  cursor: pointer;
}
/* 分页区域样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination{
  margin-top: 30px;
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  padding-left: 245px;
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
.pageDeavtive{
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
/* 分页区域样式结束 */
.productAndCount h3{
  font-size: 22px;
  line-height: 22px;
  height: 22px;
  margin: 43px 0 23px 0;
}
.productInfo{
  height: 160px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
}
.productInfo img{
  display: block;
  width: 100px;
  height: 100px;
  margin-top: 30px;
  margin-right: 20px;
}
.productInfo h4{
  margin-top: 29px;
  font-size: 18px;
  margin-bottom: 30px;
}
.productInfo p{
  margin-bottom: 5px;
}
.finalCount{
  height: 170px;
  margin-top: 30px;
  background: #f4f4f4;
  padding-right: 89px;
  padding-top: 30px;
  padding-bottom: 30px;
}
.finalCount0{
  display: flex;
  font-size: 16px;
  height: 16px;
  line-height: 16px;
}
.finalCount01{
  margin-bottom: 32px;
}
.finalCount02{
  margin-bottom: 32px;
}
.finalCount1{
  width: 908px;
  text-align: right;
}
.finalCount2{
  width: 132px;
  text-align: right;
  font-weight: bold;
  color: #333333;
}
.finalCount22{
  color: #bf1b22;
  font-size: 18px;
}
.confirmCount{
  margin-top: 30px;
  margin-left: 979px;
  width: 150px;
  height: 40px;
  background: #1D65A8;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  user-select: none;
  cursor: pointer;
}
</style>
